// components/commons/dialog/dialog.js
Component({
    /**
     * 组件的属性列表
     */
    properties: {
        dialogConfig: {
            type: Object,
            value: {}
        },
        isOpen: {
            type: Boolean,
            value: false
        }
    },
    externalClasses: ["class-name","content-class-name", "body-class-name"],

    /**
     * 组件的初始数据
     */
    data: {},

    /**
     * 组件的方法列表
     */
    methods: {
        btnClick: function(e) {
            let { index: btnIndex } = e.target.dataset;
            let btn = this.data.dialogConfig.btns[btnIndex];
            if (btn.onClick) {
                var evDetail = { callBack: btn.onClick };
                this.triggerEvent(btn.onClick, evDetail);
            }
        }
    }
});
